angular.module('unergie.main')
.factory('TogglerUtils', (BoFeaturesService) => {
    const isPlum = () => {
        const provider = BoFeaturesService.get('provider')
        return provider === 'plum'
    }

    return {
        isPlum,
    }
})
